import React, { useEffect } from "react";
import Store from "./Store";
import { Helmet } from "react-helmet";
import StoryContainer from "./container/StoryContainer";
import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import { getCountryFromUrl, getEnvironment, getCookieyesId } from "./utils/helpers";
import PlayerPage from "./components/PlayerPage";
import CopyLinkContainer from "./components/CopyLinkContainer/CopyLinkContainer";

import { openLightbox, updateLightbox, handleHover, updatePreview } from "./utils/storyUIHandlers";

ReactGA.initialize("G-9R3S0492XE");
let country = getCountryFromUrl();
const environment = getEnvironment();
let cookieyesId = getCookieyesId(environment);

const clarityIds = {
  'us': 'ub4dxecrzl',
  'aus': 'ub4emhg236',
  'ie': 'ub4f8vxs7i',
  'uk': 'ub4dd11iur'
};

let clarityId = clarityIds[country] || 'ub4dd11iur'; 

function App() {
   useEffect(() => {
    // Load Clarity script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${clarityId}`;
    
    const clarityInit = document.createElement('script');
    clarityInit.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;
    
    document.head.appendChild(clarityInit);
  }, []);

  return (
    <Store className="App">
      <Helmet>
        <meta name="robots" content="noindex"></meta>
        {cookieyesId && country === 'uk' && (
          <script id="cookieyes" type="text/javascript" src={`https://cdn-cookieyes.com/client_data/${cookieyesId}/script.js`}></script>
        )}
        <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0130/4183.js" async="async"></script>

      </Helmet>
      <Router>
        <Switch>
          {/* <Route path="/:guid/player/:id" exact>
            <PlayerPage />
          </Route> */}
          <Route path="/:guid" exact>
            <StoryContainer />
          </Route>
        </Switch>
        <CopyLinkContainer mount={updatePreview} callbackHandler={openLightbox} updateLightbox={updateLightbox} />
      </Router>
    </Store>
  );
}

export default App;
